import { ContentNugget, PanelNugget } from '@backrs_ui/common-ui';

import { nuggetMapper } from '@backrs_ui/grow-ui/src/components/Nuggets/nugget.util';
import { LubavResource } from '@backrs_ui/grow-ui/src/models/models';
import { setCurrentDialogNugget } from '@backrs_ui/grow-ui/src/redux/contentNugget/contentNugget';
import { useAppDispatch } from '@backrs_ui/grow-ui/src/redux/hooks';

type ResourceNuggetProps = Readonly<{
  resource: LubavResource;
}>;

export const ResourceNugget = ({ resource }: ResourceNuggetProps) => {
  const dispatch = useAppDispatch();

  const resourceNugget: ContentNugget | undefined = resource.metadata
    ? {
        ...resource.metadata,
        id: parseInt(resource.id),
      }
    : undefined;

  if (!resourceNugget) {
    return null;
  }

  return (
    <PanelNugget
      key={resource.id}
      title={resourceNugget.title || ''}
      size="SMALL"
      variant={nuggetMapper({ nugget: resourceNugget })}
      subText={resource.relevance}
      onClick={() => {
        dispatch(setCurrentDialogNugget(resourceNugget));
      }}
    />
  );
};
